import { AEMErrorMessage } from '../../../models';

export const BenefitsErrorMessage: AEMErrorMessage = {
  action: {
    label: 'View SkyMiles Member Benefits Page',
    url: '/us/en/skymiles/medallion-program/medallion-benefits',
    id: 'viewSkyMilesMemberBenefitsPage'
  },
  component: 'benefits',
  errorId: [
    {
      errorCode: ''
    }
  ],
  featureTitle: 'Your SkyMiles Benefilts',
  errorMessageDescription:
    'Sorry, we’re currently unable to display your SkyMiles Benfits. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
